import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import { Axios } from "../config";
import "../Style/HomePage.css";
import BG1 from "../Images/BG3.jpeg";
import BG4 from "../Images/BG4.jpeg";
import Sherbon from "../Images/Sherbon.png";
import RealCarson from "../Images/RealCarson.jpeg";
import Handi from "../Images/Handi.png";
import Bolt from "../Images/Bolt.png";
import Assad from "../Images/Assad.png";
import Revital from "../Images/Revital.jpg";

function HomePage() {
  const [Runs, setRuns] = useState([]);
  const [Fours, setFours] = useState([]);
  const [Sixes, setSixes] = useState([]);
  const [Wickets, setWickets] = useState([]);
  const [Economy, setEconomy] = useState([]);
  const [Catches, setCatches] = useState([]);
  const [RunOuts, setRunOuts] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    Axios.post("/GetOverAllPlayersData")
      .then((response) => {
        console.log("Data fetched successfully:", response.data);
        // Extracting the top 3 run scorers
        const sortedPlayersRuns = response.data.sort(
          (a, b) => b.RunsScored - a.RunsScored
        );
        const top3RunScorers = sortedPlayersRuns.slice(0, 3);
        setRuns(top3RunScorers);

        const sortedPlayersFours = response.data.sort(
          (a, b) => b.Fours - a.Fours
        );
        const top3Fours = sortedPlayersFours.slice(0, 3);
        setFours(top3Fours);

        const sortedPlayersSixes = response.data.sort(
          (a, b) => b.Sixes - a.Sixes
        );
        const top3Sixes = sortedPlayersSixes.slice(0, 3);
        setSixes(top3Sixes);

        const sortedPlayersWickets = response.data.sort(
          (a, b) => b.WicketsTaken - a.WicketsTaken
        );
        const top3Wickets = sortedPlayersWickets.slice(0, 3);
        setWickets(top3Wickets);

        const sortedPlayersEconomy = response.data
          .filter(
            (player) =>
              player.BowlingEconomy !== null && player.OversBowled > 10
          )
          .sort((a, b) => a.BowlingEconomy - b.BowlingEconomy);
        const top3Economy = sortedPlayersEconomy.slice(0, 3);
        setEconomy(top3Economy);

        const sortedPlayersCatches = response.data.sort(
          (a, b) => b.CatchesTaken - a.CatchesTaken
        );
        const top3Catches = sortedPlayersCatches.slice(0, 3);
        setCatches(top3Catches);

        const sortedPlayersRunOuts = response.data.sort(
          (a, b) => b.RunOuts - a.RunOuts
        );
        const top3RunOuts = sortedPlayersRunOuts.slice(0, 3);
        setRunOuts(top3RunOuts);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  return (
    <div>
      <React.Fragment>
        <Navbar />
      </React.Fragment>
      <div className="top20 homepageFull">
        <div className="homePageLayout">
          <div className="bannerPicture">
            <img src={BG4} alt="Banner" />
          </div>
          <div className="HomePageCenterDiv">
            <div className="teamNameWhite">
              <b>Shaheen Cricket Club YYC - Season 2024</b>
            </div>
            <div className="CenterDivSmall">
              <div className="homePage">
                <div className="records">
                  <h2>Most Runs</h2>
                  <ul>
                    {Runs.map((player, index) => (
                      <li key={index}>
                        {player.PlayerName} - {player.RunsScored}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="records">
                  <h2>Most Fours</h2>
                  <ul>
                    {Fours.map((player, index) => (
                      <li key={index}>
                        {player.PlayerName} - {player.Fours}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="records">
                  <h2>Most Sixers</h2>
                  <ul>
                    {Sixes.map((player, index) => (
                      <li key={index}>
                        {player.PlayerName} - {player.Sixes}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="records">
                  <h2>Most Wickets</h2>
                  <ul>
                    {Wickets.map((player, index) => (
                      <li key={index}>
                        {player.PlayerName} - {player.WicketsTaken}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="records">
                  <h2>Bowling Economy</h2>
                  <ul>
                    {Economy.map((player, index) => (
                      <li key={index}>
                        {player.PlayerName} - {player.BowlingEconomy}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="records">
                  <h2>Most Catches</h2>
                  <ul>
                    {Catches.map((player, index) => (
                      <li key={index}>
                        {player.PlayerName} - {player.CatchesTaken}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="records">
                  <h2>Most RunOuts</h2>
                  <ul>
                    {RunOuts.map((player, index) => (
                      <li key={index}>
                        {player.PlayerName} - {player.RunOuts}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              {/*  <div className="sponsors">
                <div className="teamNameWhite">Sponsors</div>
                <div className="sponsorImages">
                  <img src={RealCarson} alt="Banner" />
                  <img src={Assad} alt="Banner" />
                  <img src={Revital} alt="Banner" />
                  <img src={Handi} alt="Banner" />
                  <img src={Sherbon} alt="Banner" />
                  <img src={Bolt} alt="Banner" />
                </div>
              </div> */}
            </div>
          </div>
          <div className="bannerPicture">
            <img src={BG1} alt="Banner" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
